import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AlertTriangle, BookOpen, MessageCircle } from "lucide-react";
import gra from '../../public/images/✍️.png';
import voc from '../../public/images/⚡.png';
import flu from '../../public/images/⚡.png'; // different image for fluency
import '../styles/feedback.css';

interface Tip {
  tag: string;
  text?: string;
  text_en?: string;
}

interface NextFocusProps {
  tips: Tip[];
  isGuest?: boolean;
}

// Map tag keywords to icon, color, and image
const typeMap: Record<string, { icon: any; bgColor: string; img: any; color: string }> = {
  grammar: { icon: AlertTriangle, bgColor: "#EFF6FF", img: gra, color: '#1E40AF' }, // amber
  vocabulary: { icon: BookOpen, bgColor: "#F0FDF4", img: voc, color: '#166534' },   // green
  fluency: { icon: MessageCircle, bgColor: "#FEFCE8", img: flu, color: '#9A3412' },
  pronunciation: { icon: AlertTriangle, bgColor: "#EFF6FF", img: gra, color: '#1E40AF' }, // orange
  comprehension: { icon: MessageCircle, bgColor: "#FDF2F8", img: flu, color: '#9D174D' }, // pink-ish for comprehension
};


const NextFocus = ({ tips, isGuest = false }: NextFocusProps) => {
  const limitedTips = tips.slice(0, 3);
  return (
    <div className="next-focus-grid">
      {limitedTips.map((tip, index) => {
        const key = tip.tag.toLowerCase();
        const { icon: Icon, bgColor, img } = typeMap[key] || {
          icon: MessageCircle,
          bgColor: "#F0FDF4", // gray fallback
          img: flu,
        };

        const tipText = tip.text || tip.text_en || "";

        return (
          <div key={index} className="tip-card">
            <div className="tip-card-inner">
              <div className="tip-badge" style={{ backgroundColor: bgColor, color: typeMap[key]?.color || '#000', }}>
                <img src={img} alt="" />
                {tip.tag}
              </div>
              <p className={`tip-text ${isGuest ? 'blur-sm blur-fade' : ''}`}>{tipText}</p>
            </div>

          </div>
        );
      })}
    </div>

  );
};

export default NextFocus;
